import React, { useState , useEffect } from 'react';
import $ from 'jquery';
import Swal from 'sweetalert2'
import { BsArrowRightCircleFill } from "react-icons/bs";
import Main_Navbar from './Main_Navbar';
import BDA_cards from './BDA_cards';

function BDA_job() {
  useEffect(()=>{
    document.title= 'Business Development Executive | InternsElite';
  },[]);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        mobileNo: '',
        collegeName: '',
      });
    
      const [nameError, setNameError] = useState(" "); 
      const [emailError, setEmailError] = useState("");
      const [phoneError, setPhoneError] = useState("");
      const [collegeError, setCollegeError] = useState("");
    
      const handleInputChange = (event) => {
        const { name, value } = event.target;
    
        if (name === 'fullName') {
          if (!value || !/^[A-Za-z\s]+$/.test(value)) {
            setNameError(`Invalid name format.`);
          }  
          else {
            setNameError("");
          }
        }
        
        if (name === 'email') {
          if (!value || !/\S+@\S+\.\S+/.test(value)) {
            setEmailError("Invalid email format");
          } else {
            setEmailError("");
          }
        
        }
    
        if (name === 'mobileNo') {
          if (!value || !/^\d{10}$/.test(value)) {
            setPhoneError("Length Should be 10 Digit");
          } else {
            setPhoneError("");
          }
        }
        if (name === 'collegeName') {
          if (!value || !/^[A-Za-z\s]+$/.test(value)) {
            setCollegeError(`Invalid College Name format.`);
          }  
          else {
            setCollegeError("");
          }
        }    
        setFormData({
          ...formData,
          [name]: value,
        });
      };
      
    
      const handleSubmit = async(event) => {
        event.preventDefault();
        $.ajax({
          url: 'https://forms.internselite.net/BDAform',
          type: 'POST',
          data: { fullName: $('[name="fullName"]').val(),
          mobileNo: $('[name="mobileNo"]').val(),
          email: $('[name="email"]').val(),
          collegeName: $('[name="collegeName"]').val()
           },
          success: function (response) {
            Swal.fire({
              title: "Form Submitted!",
              text: "Thank you for applying to be a Business Development Executive! Your application has been received, You will get the Interview call soon. For Resume mail Us to support@internselite.com",
              icon: "success"
            });
              $('[name="collegeName"]').val('');
              $('[name="fullName"]').val('');
              $('[name="mobileNo"]').val('');
              $('[name="email"]').val('');
          },
          error: function (error) {
            console.error('Error:', error);
          }
      });
        
      };

  return (
    <div>
        {/* -----------------------------Mobile View------------------------- */}
        <div className='Mobile_BDA_background_element d-sm-block d-md-none mt-5 pt-4'>
        <div className='container pb-5 pt-4'>
          <div className='mobile_BDA_text'>
              <h1 className='display-6 text-center'>InternsElite- Business Development Executive Profile</h1>
              <p className='text-center'>Experience professional transformation with the InstersElite Business Development Executive Program. This expansive offering  gives you insider knowledge, cutting-edge skills, and industry connections. Our comprehensive professional development programme for aspiring company executives promotes strategic thinking, excellent communication, and market knowledge. </p>
              <span>Job Description:-</span>
              <ul className=''>
              <li className='pt-3'>Explore students' aspirations for their future careers, answering their questions and easing their fears so you can help them succeed.</li>
              <li className='pt-2'>Learn how students' individual experiences impact their job choices by delving into their educational and personal backgrounds.</li>
              <li className='pt-2'>Create individualised career plans that play to their interests and play to their skills.</li>
              <li className='pt-2'>Give students all the information they need about the courses they're interested in, making sure they know how they will help them achieve their career goals.</li>
              <li className='pt-2'>Help students make well-informed selections by pointing out options and excellent career paths.</li>
              <li className='pt-2'>Effortlessly record consultations to make learning easier for students.</li>
              <li className='pt-2'>Successfully ending the consultation and leaving students with relevant information is crucial for ensuring a good outcome.</li>
              <li className='pt-2'>Help students better comprehend the processes involved in pursuing their chosen professions by directing them toward the appropriate educational programs.</li>
              </ul>
              <span className=''>Qualifications:</span>
              <p className='pt-2 pb-3'>B.Tech (all specialisation),MBA(all specialisation),BBA(all specialisation),BCA,MCA, B.com.</p>
          </div>
          <div className='pb-2'>
          <div className='BDA_form_text shadow-lg px-3 py-4'>
              <div className='text-center border-bottom pb-2'>
              <span>Apply Now...</span>
              </div>
              <div className=''>
                  <form onSubmit={handleSubmit}>
                  <div class="mt-3">
                  <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
                  <input
                  className='form-control'
                  type="text"
                  id="fullName"
                  name="fullName"
                  placeholder="Your answer"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                  />
                  {nameError && <div className="error text-danger">{nameError}</div>}
                  </div>
                  <div class="mt-3">
                  <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
                  <input
                  className='form-control'
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your answer"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  />
                  {emailError && <div className="error text-danger">{emailError}</div>}
                  </div>
                  <div class="mt-3">
                  <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
                  <input
                  className='form-control'
                  type="tel"
                  id="mobileNo"
                  name="mobileNo"
                  placeholder="+91 xxxxxxxxxx"
                  value={formData.mobileNo}
                  onChange={handleInputChange}
                  required
                  />
                  {phoneError && <div className="error text-danger">{phoneError}</div>}
                  </div>
                  <div class="my-3">
                  <label for="collegeName" class="form-label pb-2 fw-bold contact_form">College Name</label>
                  <input
                  className='form-control'
                  type="text"
                  id="collegeName"
                  name="collegeName"
                  placeholder="Your answer"
                  value={formData.collegeName}
                  onChange={handleInputChange}
                  required
                  />
                  {collegeError && <div className="error text-danger">{collegeError}</div>}
                  </div>
                  <div className='row mt-2 pt-4'>
                      <div className='d-flex justify-content-center'>
                      <button className="text-white shadow-sm  fs-5 px-5 pt-1 pb-2 Navbar_button">Submit</button>
                      </div>
                  </div>
                  </form>
              </div>
          </div>
          </div>
        </div>
        </div>


        {/* ---------------------------Desktop View--------------------------------- */}
        <div className='BDA_background_element d-none d-md-block  my-5'>
        <div className='container pt-5 mt-5'>
            <div className='row mt-3'>
                <div className='col-md-7 px-2 pt-3'>
                    <div className='BDA_text'>
                        <h1 className='display-6'>InternsElite- Business Development Executive Profile</h1>
                        <p className='pt-2'>Experience professional transformation with the InstersElite Business Development Executive Program. This expansive offering  gives you insider knowledge, cutting-edge skills, and industry connections. Our comprehensive professional development programme for aspiring company executives promotes strategic thinking, excellent communication, and market knowledge.</p>
                        <span>Job Description:-</span>
                        <ul className='pb-3'>
                            {/* <li className='pt-4'><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''> Inspecting student' career-related aspirations, concerns, and uncertainties throughout the consultation</a></li>
                            <li className='px-2'><a className='px-4' href=''>process.</a></li>
                            <li className='pt-2'><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''> Reviewing student' personal and educational undertakings and how the manifestation of these might inform</a></li>
                            <li className='px-2 pb-2'><a className='px-4' href=''>their prospective job-related choices.</a></li>
                            <li className=''><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Proposing career-related options that are congruent with your substantiated insights.</a></li>
                            <li className='py-2'><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Providing them a complete information about the Courses which course is beneficial to them.</a></li>
                            <li className=''><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Informing student about potential shortcomings in their skill sets and devising strategies to remedy these.</a></li>
                            <li className='py-2'><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Pinpointing and informing student of potentially helpful career-related opportunities.</a></li>
                            <li className=''><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Documenting the sales process and closing.</a></li>
                            <li className='py-2'><BsArrowRightCircleFill  size="20px" color="#3d2e7c" /><a className='px-2' href=''>Advise students about what courses and educational programs they need for particular careers</a></li> */}
                            <li className='pt-4'>Explore students' aspirations for their future careers, answering their questions and easing their fears so you can help them succeed.</li>
                            <li className='pt-2'>Learn how students' individual experiences impact their job choices by delving into their educational and personal backgrounds.</li>
                            <li className='pt-2'>Create individualised career plans that play to their interests and play to their skills.</li>
                            <li className='pt-2'>Give students all the information they need about the courses they're interested in, making sure they know how they will help them achieve their career goals.</li>
                            <li className='pt-2'>Help students make well-informed selections by pointing out options and excellent career paths.</li>
                            <li className='pt-2'>Effortlessly record consultations to make learning easier for students.</li>
                            <li className='pt-2'>Successfully ending the consultation and leaving students with relevant information is crucial for ensuring a good outcome.</li>
                            <li className='pt-2'>Help students better comprehend the processes involved in pursuing their chosen professions by directing them toward the appropriate educational programs.</li>
                        </ul>
                        <span className=''>Qualifications:</span>
                        <p className='pt-2'>B.Tech (all specialisation),MBA(all specialisation),BBA(all specialisation),BCA,MCA, B.com.</p>
                    </div>
                </div>
                <div className='col-md-5'>
                <div className='mt-5 px-5 py-5 BDA_form_text shadow-lg '>
                    <span className=''>Apply Now...</span>
                    <div className=''>
                    <form onSubmit={handleSubmit}>
                        <div class="mt-4">
                        <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
                        <input
                        className='form-control'
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Your answer"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                        />
                        {nameError && <div className="error text-danger">{nameError}</div>}
                        </div>
                        <div class="mt-3">
                        <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
                        <input
                        className='form-control'
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Your answer"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        />
                        {emailError && <div className="error text-danger">{emailError}</div>}
                        </div>
                        <div class="mt-3">
                        <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
                        <input
                        className='form-control'
                        type="tel"
                        id="mobileNo"
                        name="mobileNo"
                        placeholder="+91 xxxxxxxxxx"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                        />
                        {phoneError && <div className="error text-danger">{phoneError}</div>}
                        </div>
                        <div class="my-3">
                        <label for="collegeName" class="form-label pb-2 fw-bold contact_form">College Name</label>
                        <input
                        className='form-control'
                        type="text"
                        id="collegeName"
                        name="collegeName"
                        placeholder="Your answer"
                        value={formData.collegeName}
                        onChange={handleInputChange}
                        required
                        />
                        {collegeError && <div className="error text-danger">{collegeError}</div>}
                        </div>
                        <div className='row mt-2 pt-4'>
                            <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm  fs-5 px-5 pt-1 pb-2 Navbar_button">Submit</button>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default BDA_job
